import styled from 'styled-components';

export const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 99999;
`;

export const Container = styled.div`
  width: 363px;
  height: 210px;
  background: #f5f7fa;
  border-radius: 6px;
  box-shadow: (5px 10px 40px rgba(0, 0, 0, 0.4));
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Title = styled.h4`
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  text-align: center;

  color: #475466;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  min-width: 190px;
  max-width: 400px;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  button {
    width: 80px;
    height: 36px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    box-sizing: border-box;
    border: 1px solid #4a90e2;
    justify-content: center;
  }

  .button-accept {
    background: #4a90e2;
    color: #f5f7fa;
  }

  .button-reject {
    border: 1px solid #4a90e2;
    color: #4a90e2;
  }
`;
